import { Box, Button, Chip, Option, Select, Stack } from "@mui/joy";
import {
  Pagination,
  PaginationItem,
  Paper,
  Typography,
  Zoom,
} from "@mui/material";
import { useEffect, useState } from "react";
import { centrado } from "../utils/Estilos";
import { theme2 } from "../theme";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import tienda from "../assets/banner/bannerart2.jpeg";
import { useNavigate } from "react-router-dom";
import { Cargando } from "../utils/Cargando";
import no from "../assets/image/no.png";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

export const Productos = () => {
  const [productos, setProductos] = useState(null);

  const especialidades = useSelector(
    (state) => state.especialidades?.especialidades ?? [],
  );
  const espeImagenes = useSelector(
    (state) => state.especialidades?.espeImagenes ?? [],
  );

  const [productosFiltrados, setProductosFiltrados] = useState([]);

  const limitador = 10;

  const [pagina, setPagina] = useState(1);

  const [imagenes2, setImagenes2] = useState([]);

  const [filtro, setFiltro] = useState({
    orden: "Antiguo",
    especialidad: "Todos",
    producto: "Todos",
  });

  const navigate = useNavigate();

  useEffect(() => {
    cargar();
    cargarFiltros();
  }, []);

  useEffect(() => {
    let info = {
      orden: filtro?.orden ?? "Antiguo",
      especialidad: filtro?.especialidad ?? "Todos",
      producto: filtro?.producto ?? "Todos",
    };
    localStorage.setItem("filtros", JSON.stringify(info));
  }, [filtro]);

  function cargarFiltros() {
    let info = localStorage.getItem("filtros");
    info = info
      ? JSON.parse(info)
      : {
          orden: "Antiguo",
          especialidad: "Todos",
          producto: "Todos",
        };

    setFiltro(info);
  }

  useEffect(() => {
    setProductosFiltrados(
      (productos ?? []).filter((val) => {
        if (filtro?.especialidad === "Todos") {
          if (filtro?.producto === "Todos") {
            return true;
          } else {
            return val?.categorias?.includes(filtro?.producto);
          }
        } else {
          if (filtro?.producto === "Todos") {
            return val?.especialidades?.includes(filtro?.especialidad);
          } else {
            return (
              val?.categorias?.includes(filtro?.producto) &&
              val?.especialidades?.includes(filtro?.especialidad)
            );
          }
        }
      }),
    );
  }, [filtro, productos]);

  function cargarImagen(etiqueta) {
    let ind = imagenes2.findIndex((val) => val?.name === etiqueta);
    if (ind >= 0) {
      return imagenes2[ind].img;
    }
    return null;
  }

  async function cargarImagenes2(productos) {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    for (const el of productos) {
      if (el?.fotoId) {
        await fetch(
          "https://portal.publimed.net/api/v1/Attachment/file/" + el?.fotoId,
          requestOptions,
        )
          .then((response) => response.blob())
          .then((result) => {
            setImagenes2((prev) => [
              ...prev,
              { img: URL.createObjectURL(result), name: el?.fotoId },
            ]);
          })
          .catch((error) => console.error(error));
      }
    }
  }

  function cargar() {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `https://portal.publimed.net/api/v1/CProducto?searchParams={"where": [{ "type": "equals", "attribute": "estado","value":"ACTIVO"},
      { "type": "equals", "attribute": "tipo","value":"CON STOCK"}],
      "select": ["posicion1Id","posicion2Id","posicion3Id","posicion4Id","posicion5Id",
      "especialidadsIds","id","name","deleted","description","precio","tipo","tipo1","tipo2","precio1","precio2","especialidades","descuento","precioSinDescuento","categorias","fotoId","fotoName"]}`,
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        setProductos([
          ...res.list.map((val) => {
            let precios = [];
            if (val?.posicion1Id === null) {
              precios.push(parseFloat(val?.precio1));
            }
            if (
              [
                val?.posicion2Id,
                val?.posicion3Id,
                val?.posicion4Id,
                val?.posicion5Id,
              ].filter((val) => val === null).length > 0
            ) {
              precios.push(parseFloat(val?.precio2));
            }

            if (precios.length === 0) {
              return {
                ...val,
                especialidades:
                  val?.especialidadsIds?.length > 0
                    ? Object.values(val?.especialidadsNames)
                    : val?.especialidades,
                etiqueta:
                  (val?.especialidadsIds?.length > 0
                    ? Object.values(val?.especialidadsNames)
                    : val?.especialidades) ?? [],
                minimo: 0,
                maximo: 0,
              };
            }

            return {
              ...val,
              etiqueta:
                (val?.especialidadsIds?.length > 0
                  ? Object.values(val?.especialidadsNames)
                  : val?.especialidades) ?? [],
              especialidades:
                val?.especialidadsIds?.length > 0
                  ? Object.values(val?.especialidadsNames)
                  : val?.especialidades,
              minimo: Math.min(...precios),
              maximo: Math.max(...precios),
            };
          }),
        ]);

        cargarImagenes2(res.list);
      })
      .catch((error) => {
        console.error(error);
        setProductos([]);
      });
  }

  return (
    <Box sx={{ ...centrado, width: "100%", flexWrap: "wrap" }}>
      <Helmet>
        <title>{"Publimed Store - Tienda"}</title>
      </Helmet>
      <Cargando open={!productos || especialidades.length === 0} />
      <Box
        sx={{
          backgroundImage: "url(" + tienda + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "top",
          height: "400px",
          width: "100%",
        }}
      />
      {/* <Typography
        variant="h3"
        color="white"
        fontWeight={"bold"}
        align="center"
        sx={{ width: "100%", marginTop: "-300px" }}
      >
        Tienda
      </Typography> */}
      {productos?.length !== 0 && (
        <>
          <Box sx={{ width: "90%" }} py={2}>
            {/* <Typography variant="h5" fontWeight={"bold"} pb={2}>
          Filtros
        </Typography> */}
            <Stack direction={"row"}>
              <Typography fontWeight={"bold"} pt={0.5} px={1}>
                Ordenar:
              </Typography>
              <Select
                sx={{ width: "200px" }}
                value={filtro?.orden}
                onChange={(e, n) => {
                  setPagina(1);
                  setFiltro({ ...filtro, orden: n });
                }}
              >
                <Option value={"Nuevo"}>Nuevo</Option>
                <Option value={"Antiguo"}>Antiguo</Option>
              </Select>
            </Stack>
            <br />
            <Stack direction={"row"}>
              <Typography fontWeight={"bold"} pt={0.5} px={1}>
                Producto:
              </Typography>
              <Select
                sx={{ width: "200px" }}
                value={filtro?.producto ?? null}
                onChange={(e, n) => {
                  setPagina(1);
                  setFiltro({
                    ...filtro,
                    producto: n,
                  });
                }}
              >
                <Option value={"Todos"} key={"Todos"}>
                  Todos
                </Option>
                <Option value={"ARTICULO MEDICO"} key={"ARTICULO MEDICO"}>
                  Artículo Médico
                </Option>
                <Option value={"LIBRO DIGITAL"} key={"LIBRO DIGITAL"}>
                  Libro Digital
                </Option>
              </Select>
            </Stack>
            <br />

            <Stack direction={"row"}>
              <Typography fontWeight={"bold"} pt={0.5} px={1}>
                Especialidad:
              </Typography>
              {especialidades.length > 0 ? (
                <Select
                  sx={{ width: "200px" }}
                  value={filtro?.especialidad ?? null}
                  onChange={(e, n) => {
                    setPagina(1);
                    setFiltro({
                      ...filtro,
                      especialidad: n,
                    });
                  }}
                >
                  <Option value={"Todos"}>Todos</Option>
                  {especialidades?.map((val) => (
                    <Option value={val} key={val}>
                      {val}
                    </Option>
                  ))}
                </Select>
              ) : (
                <Select
                  sx={{ width: "200px" }}
                  value={filtro?.especialidad ?? null}
                ></Select>
              )}
            </Stack>

            <br />
            <Typography px={1}>
              Mostrando de{" "}
              <strong>
                {pagina * limitador - limitador + 1} -{" "}
                {Math.min(...[pagina * limitador, productosFiltrados?.length])}
              </strong>{" "}
              de {productosFiltrados?.length} productos
            </Typography>
          </Box>

          <Box sx={{ width: "90%", ...centrado, flexWrap: "wrap" }}>
            {productosFiltrados
              ?.sort((a, b) => {
                if (filtro?.orden === "Nuevo") {
                  return new Date(b?.createdAt) - new Date(a?.createdAt);
                } else {
                  return new Date(a?.createdAt) - new Date(b?.createdAt);
                }
              })
              .slice(pagina * limitador - limitador, pagina * limitador)
              .map((val) => (
                <Zoom in={val?.id?.length > 0} key={val?.id}>
                  <Box sx={{ padding: "10px", width: "280px" }}>
                    <Paper
                      elevation={2}
                      sx={{
                        ":hover": {
                          boxShadow: 20,
                        },
                        padding: "20px",
                        border: 1,
                        borderRadius: "25px",
                        borderColor: theme2.palette.primary.main,
                      }}
                    >
                      <Stack spacing={2}>
                        <Box
                          sx={{
                            height: "0px",
                            padding: "0px",
                            margin: "0px",
                            textAlign: "right",
                          }}
                        >
                          {val?.descuento === "SI" && (
                            <Chip
                              sx={{ marginBottom: "-40px", marginRight: "5px" }}
                              color="danger"
                              variant="solid"
                            >
                              {" "}
                              Oferta
                            </Chip>
                          )}
                        </Box>

                        {val?.fotoId && (
                          <img
                            alt={"fotoProducto"}
                            src={cargarImagen(val?.fotoId) ?? no}
                            width={"100%"}
                          />
                        )}
                        {val?.especialidades?.length > 0 && !val?.fotoId && (
                          <img
                            alt={"fotoProducto"}
                            src={
                              espeImagenes[
                                val?.especialidades.filter(
                                  (val2) =>
                                    espeImagenes[val2] !==
                                    "https://publimed.net/iconos/new/no.png",
                                )[0]
                              ] ?? no
                            }
                            width={"100%"}
                          />
                        )}

                        <Typography
                          fontWeight={"bold"}
                          sx={{
                            height: "70px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            fontSize: "15px",
                            WebkitLineClamp: 3,
                            textOverflow: "ellipsis",
                          }}
                        >
                          {val?.categorias === "ARTICULO MEDICO"
                            ? "Artículo Médico: "
                            : ""}
                          {val?.categorias === "LIBRO DIGITAL"
                            ? "Libro Digital: "
                            : ""}{" "}
                          {val?.name}
                        </Typography>
                        {val?.especialidades?.length > 0 && (
                          <Box>
                            <strong>Especialidades:</strong>
                            <Typography sx={{ fontSize: "14px" }}>
                              {val?.especialidades?.join(", ")}
                            </Typography>
                          </Box>
                        )}
                        <Box>
                          {val?.descuento === "SI" && (
                            <Chip
                              color="neutral"
                              sx={{ textDecoration: "line-through" }}
                            >
                              {"$ " +
                                parseFloat(val?.precioSinDescuento).toFixed(2)}
                            </Chip>
                          )}
                          {val?.tipo === "SIN STOCK" ? (
                            <Chip color="success">
                              {"$ " + parseFloat(val?.precio).toFixed(2)}
                            </Chip>
                          ) : (
                            <>
                              {val?.minimo === val?.maximo &&
                              val?.minimo === 0 ? (
                                <Chip color="danger">CUPOS LLENOS</Chip>
                              ) : (
                                <Chip color="success">
                                  {"$ " + parseFloat(val?.minimo).toFixed(2)}
                                  {val?.minimo !== val?.maximo && (
                                    <>
                                      {" ~ $ " +
                                        parseFloat(val?.maximo).toFixed(2)}
                                    </>
                                  )}
                                </Chip>
                              )}
                            </>
                          )}
                        </Box>
                        <Button
                          onClick={() => {
                            navigate("/articulo/" + val?.id);
                          }}
                          variant="solid"
                        >
                          <Typography
                            fontWeight={"bold"}
                            sx={{ textAlign: "center" }}
                          >
                            Ver más
                          </Typography>
                        </Button>
                      </Stack>
                    </Paper>
                  </Box>
                </Zoom>
              ))}
          </Box>

          <Box sx={{ width: "100%", ...centrado }} pb={2}>
            <Stack spacing={2} py={2}>
              <Pagination
                size="large"
                page={pagina}
                onChange={(e, v) => {
                  setPagina(v);
                }}
                count={Math.ceil(
                  (productosFiltrados ?? [])?.length / limitador,
                )}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                    {...item}
                  />
                )}
              />
            </Stack>
          </Box>
        </>
      )}
    </Box>
  );
};
